import { parseString } from 'xml2js';
import { PaperXmlToSalt } from './transpiler';

PaperXmlToSalt.xmlParser = parseString;

export * from './transpiler';
